import React from "react";
import PropTypes from "prop-types";

import { MultiToggle } from './MultiToggle';
require("./MultiToggle.css");

const groupOptions = [
	{
		displayName: ' ',
		selectedDisplayName: 'NOK',
		value: 1,
		optionClass: 'red'
	},
	{
		displayName: ' ',
		selectedDisplayName: 'Neutral',
		value: 0,
		optionClass: 'gray'
	},
	{
		displayName: ' ',
		selectedDisplayName: 'OK',
		value: 2,
		optionClass: 'green'
	},
];

const OKToggle = (props) => {
	const name = props.name;
	const onChange = props.onChange;
	const value = props.value;
	const disabled = props.disabled ? props.disabled : null;
	const kleurbalk = props.kleurbalk;

	return (
		<MultiToggle
			kleurbalk={kleurbalk}
			disabled={disabled}
			options={groupOptions}
			selectedOption={value}
			onSelectOption={onChange}
			name={name}
		/>
	);
};

OKToggle.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	]),
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	kleurbalk: PropTypes.bool
};

export default OKToggle;
